import Index from 'src/pages/Warehouses/ProductConfig/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/warehouses/:id/product_config',
    name: 'Warnschwellen & Sollmengen konfigurieren Produkt',
    component: Index,
    meta: auth
  }
]
